export default "__VITE_ASSET__Chozj8M4__"